import { inject, computed } from 'vue';
export function useTheme(mdTheme) {
    const material = inject('$material');
    const getThemeAsset = (name) => material.getTheme(mdTheme.value).getAsset(name);
    const themeClass = computed(() => material.getThemeClass(mdTheme.value));
    const themeClassOrDefault = computed(() => material.getThemeClass(mdTheme.value || material.getDefaultTheme()));
    return { material, getThemeAsset, themeClass, themeClassOrDefault };
}
//# sourceMappingURL=components.mjs.map